module.exports = __webpack_public_path__ + "static/karma-33a147a03f4c776ba6ed9bd5dc007df7.svg";